export const countries = {
  افغانستان: "Afghanistan",
  آلبانی: "Albania",
  الجزایر: "Algeria",
  آندورا: "Andorra",
  آنگولا: "Angola",
  "آنتیگوآ و باربودا": "Antigua and Barbuda",
  آرژانتین: "Argentina",
  ارمنستان: "Armenia",
  استرالیا: "Australia",
  اتریش: "Austria",
  "جمهوری آذربایجان": "Azerbaijan",
  باهاما: "Bahamas",
  بحرین: "Bahrain",
  بنگلادش: "Bangladesh",
  باربادوس: "Barbados",
  بلاروس: "Belarus",
  بلژیک: "Belgium",
  بلیز: "Belize",
  بنین: "Benin",
  "بوتان (کشور)": "Bhutan",
  بولیوی: "Bolivia, Plurinational State of",
  "بوسنی و هرزگوین": "Bosnia and Herzegovina",
  بوتسوانا: "Botswana",
  برزیل: "Brazil",
  برونئی: "Brunei Darussalam",
  بلغارستان: "Bulgaria",
  بورکینافاسو: "Burkina Faso",
  بوروندی: "Burundi",
  کامبوج: "Cambodia",
  کامرون: "Cameroon",
  کانادا: "Canada",
  "کیپ ورد": "Cabo Verde",
  "جمهوری آفریقای مرکزی": "Central African Republic",
  چاد: "Chad",
  شیلی: "Chile",
  چین: "China",
  کلمبیا: "Colombia",
  کومور: "Comoros",
  "جمهوری کنگو": "Congo",
  "جمهوری دموکراتیک کنگو": "Congo, Democratic Republic of the",
  کاستاریکا: "Costa Rica",
  "ساحل عاج": "Côte d'Ivoire",
  کرواسی: "Croatia",
  کوبا: "Cuba",
  قبرس: "Cyprus",
  "جمهوری چک": "Czechia",
  دانمارک: "Denmark",
  جیبوتی: "Djibouti",
  دومینیکا: "Dominica",
  "جمهوری دومینیکن": "Dominican Republic",
  اکوادور: "Ecuador",
  مصر: "Egypt",
  السالوادور: "El Salvador",
  "گینه استوایی": "Equatorial Guinea",
  اریتره: "Eritrea",
  استونی: "Estonia",
  اتیوپی: "Ethiopia",
  فیجی: "Fiji",
  فنلاند: "Finland",
  فرانسه: "France",
  گابن: "Gabon",
  گامبیا: "Gambia",
  گرجستان: "Georgia",
  آلمان: "Germany",
  غنا: "Ghana",
  یونان: "Greece",
  گرنادا: "Grenada",
  گواتمالا: "Guatemala",
  گینه: "Guinea",
  "گینه بیسائو": "Guinea-Bissau",
  گویان: "Guyana",
  هائیتی: "Haiti",
  هندوراس: "Honduras",
  مجارستان: "Hungary",
  ایسلند: "Iceland",
  هند: "India",
  اندونزی: "Indonesia",
  ایران: "Iran, Islamic Republic of",
  عراق: "Iraq",
  "جمهوری ایرلند": "Ireland",
  اسرائیل: "Israel",
  ایتالیا: "Italy",
  جامائیکا: "Jamaica",
  ژاپن: "Japan",
  اردن: "Jordan",
  قزاقستان: "Kazakhstan",
  کنیا: "Kenya",
  کیریباتی: "Kiribati",
  "کره شمالی": "Korea, Democratic People's Republic of",
  "کره جنوبی": "Korea, Republic of",
  کویت: "Kuwait",
  قرقیزستان: "Kyrgyzstan",
  لائوس: "Lao People's Democratic Republic",
  لتونی: "Latvia",
  لبنان: "Lebanon",
  لسوتو: "Lesotho",
  لیبریا: "Liberia",
  لیبی: "Libya",
  لیختن‌اشتاین: "Liechtenstein",
  لیتوانی: "Lithuania",
  لوکزامبورگ: "Luxembourg",
  "مقدونیه شمالی": "North Macedonia",
  ماداگاسکار: "Madagascar",
  مالاوی: "Malawi",
  مالزی: "Malaysia",
  مالدیو: "Maldives",
  مالی: "Mali",
  مالت: "Malta",
  "جزایر مارشال": "Marshall Islands",
  موریتانی: "Mauritania",
  موریس: "Mauritius",
  مکزیک: "Mexico",
  "ایالات فدرال میکرونزی": "Micronesia, Federated States of",
  مولدووا: "Moldova, Republic of",
  موناکو: "Monaco",
  مغولستان: "Mongolia",
  مونته‌نگرو: "Montenegro",
  مراکش: "Morocco",
  موزامبیک: "Mozambique",
  میانمار: "Myanmar",
  نامیبیا: "Namibia",
  نائورو: "Nauru",
  نپال: "Nepal",
  هلند: "Netherlands",
  نیوزیلند: "New Zealand",
  نیکاراگوئه: "Nicaragua",
  نیجر: "Niger",
  نیجریه: "Nigeria",
  نروژ: "Norway",
  عمان: "Oman",
  پاکستان: "Pakistan",
  پالائو: "Palau",
  پاناما: "Panama",
  "پاپوآ گینه نو": "Papua New Guinea",
  پاراگوئه: "Paraguay",
  پرو: "Peru",
  فیلیپین: "Philippines",
  لهستان: "Poland",
  پرتغال: "Portugal",
  قطر: "Qatar",
  رومانی: "Romania",
  روسیه: "Russian Federation",
  رواندا: "Rwanda",
  "سنت کیتس و نویس": "Saint Kitts and Nevis",
  "سنت لوسیا": "Saint Lucia",
  "سنت وینسنت و گرنادین‌ها": "Saint Vincent and the Grenadines",
  ساموآ: "Samoa",
  "سان مارینو": "San Marino",
  "سائوتومه و پرنسیپ": "Sao Tome and Principe",
  "عربستان سعودی": "Saudi Arabia",
  سنگال: "Senegal",
  صربستان: "Serbia",
  سیشل: "Seychelles",
  سیرالئون: "Sierra Leone",
  سنگاپور: "Singapore",
  اسلواکی: "Slovakia",
  اسلوونی: "Slovenia",
  "جزایر سلیمان": "Solomon Islands",
  سومالی: "Somalia",
  "آفریقای جنوبی": "South Africa",
  اسپانیا: "Spain",
  سری‌لانکا: "Sri Lanka",
  سودان: "Sudan",
  سورینام: "Suriname",
  اسواتینی: "Eswatini",
  سوئد: "Sweden",
  سوئیس: "Switzerland",
  سوریه: "Syrian Arab Republic",
  تاجیکستان: "Tajikistan",
  تانزانیا: "Tanzania, United Republic of",
  تایلند: "Thailand",
  "تیمور شرقی": "Timor-Leste",
  توگو: "Togo",
  تونگا: "Tonga",
  "ترینیداد و توباگو": "Trinidad and Tobago",
  تونس: "Tunisia",
  ترکیه: "Türkiye",
  ترکمنستان: "Turkmenistan",
  تووالو: "Tuvalu",
  اوگاندا: "Uganda",
  اوکراین: "Ukraine",
  "امارات متحده عربی": "United Arab Emirates",
  بریتانیا: "United Kingdom of Great Britain and Northern Ireland",
  "ایالات متحده آمریکا": "United States of America",
  اروگوئه: "Uruguay",
  ازبکستان: "Uzbekistan",
  وانواتو: "Vanuatu",
  ونزوئلا: "Venezuela, Bolivarian Republic of",
  ویتنام: "Viet Nam",
  یمن: "Yemen",
  زامبیا: "Zambia",
  زیمبابوه: "Zimbabwe",
  "سودان جنوبی": "South Sudan",
};
